import { render, staticRenderFns } from "./BusStandardTeamConfigModal.vue?vue&type=template&id=03496fb2&scoped=true&"
import script from "./BusStandardTeamConfigModal.vue?vue&type=script&lang=js&"
export * from "./BusStandardTeamConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./BusStandardTeamConfigModal.vue?vue&type=style&index=0&id=03496fb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03496fb2",
  null
  
)

export default component.exports